import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const CompareWordsSchema = z.object({
  languages: z
    .array(languageEnumValidator)
    .optional()
    .default([LanguageEnum.RU]),
  words: z
    .array(z.string().min(1, 'Word cannot be empty'))
    .min(2, 'At least two words must be provided for comparison.')
    .max(5, 'Comparison is limited to a maximum of five words.'),
});

export type ICompareWordsDto = z.infer<typeof CompareWordsSchema>;
